import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Home, Search, ArrowLeft, FileQuestion } from "lucide-react";
import { Button } from "../components/ui/button";

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>Page non trouvée - Mon DCE Express</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-violet-50 flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          {/* Icon */}
          <div className="mb-8">
            <div className="w-24 h-24 mx-auto bg-gradient-to-br from-violet-100 to-indigo-100 rounded-full flex items-center justify-center">
              <FileQuestion className="w-12 h-12 text-violet-600" />
            </div>
          </div>
          
          {/* Error Code */}
          <h1 className="text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-indigo-600 mb-4">
            404
          </h1>
          
          {/* Message */}
          <h2 className="text-2xl font-semibold text-slate-800 mb-4">
            Page non trouvée
          </h2>
          <p className="text-slate-600 mb-8">
            Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
          </p>
          
          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/">
              <Button className="w-full sm:w-auto bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-700 hover:to-indigo-700 text-white">
                <Home className="w-4 h-4 mr-2" />
                Retour à l'accueil
              </Button>
            </Link>
            <Link to="/blog">
              <Button variant="outline" className="w-full sm:w-auto border-violet-200 text-violet-700 hover:bg-violet-50">
                <Search className="w-4 h-4 mr-2" />
                Voir le blog
              </Button>
            </Link>
          </div>
          
          {/* Back Link */}
          <button 
            onClick={() => window.history.back()}
            className="mt-6 text-sm text-slate-500 hover:text-violet-600 flex items-center justify-center gap-1 mx-auto"
          >
            <ArrowLeft className="w-4 h-4" />
            Revenir à la page précédente
          </button>
          
          {/* Helpful Links */}
          <div className="mt-12 pt-8 border-t border-slate-200">
            <p className="text-sm text-slate-500 mb-4">Pages populaires :</p>
            <div className="flex flex-wrap justify-center gap-2">
              <Link to="/veille-marches-publics" className="text-sm text-violet-600 hover:underline">
                Veille marchés publics
              </Link>
              <span className="text-slate-300">•</span>
              <Link to="/analyse-gratuite" className="text-sm text-violet-600 hover:underline">
                Analyse gratuite
              </Link>
              <span className="text-slate-300">•</span>
              <Link to="/pricing" className="text-sm text-violet-600 hover:underline">
                Tarifs
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
